export default __webpack_public_path__ + "static/media/CW__3214.3b091af6.jpg";